import ClientNameLabel from '@monorepo/common/component/client/ClientNameLabel';
import { PersonDataType } from '@monorepo/common/component/person/PersonNameLabel';
import React from 'react';
import { NavLink } from 'react-router-dom';

interface ClientNameLinkProps {
  client: {
    id: string;
    personData: PersonDataType;
  };
  showDegrees?: boolean;
}

export default function ClientNameLink({ client, showDegrees }: ClientNameLinkProps) {
  return (
    <NavLink to={`/clients/${client.id}`}>
      <ClientNameLabel client={client} showDegrees={showDegrees} />
    </NavLink>
  );
}
